import BackupApprovalsPanel from "../components/BackupApprovalsPanel";
import ManualAwayPanel from "../components/ManualAwayPanel";
import ExecutiveAccessPanel from "../components/ExecutiveAccessPanel";

/**
 * Executive-only admin surface. Groups the "run the system" concerns --
 * covering approvals when a manager is away (detected automatically, or
 * flagged manually), and granting Org-wide access -- that used to live on
 * (and clutter) the Org-wide reporting tab.
 */
export default function Admin() {
  return (
    <div className="page">
      <div className="page-header">
        <h1 className="di-h3">Admin</h1>
      </div>

      <BackupApprovalsPanel />
      <ManualAwayPanel />
      <ExecutiveAccessPanel />
    </div>
  );
}
